import React, { Component } from 'react'
import { Loader } from 'react-loaders'
import { connect } from 'react-redux'
import 'loaders.css'

class MyLoader extends Component {
    render() {
        var { isLoading } = this.props

        if (isLoading) {
            return (
                <Loader type="line-scale" color="#006e78" style={{ zIndex: "999", position: 'absolute', right: '30px', top: "10px" }} />
            )
        } else {
            return (null)
        }
    }
}

const mapStateToProps = state => {
    return {
        isLoading: state.loading.isLoading,
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyLoader)